import {
  FETCH_CUSTOMER_HISTORY_BEGIN,
  FETCH_CUSTOMER_HISTORY_SUCCESS,
  FETCH_CUSTOMER_HISTORY_FAILURE
} from "./types";
import API from "../../../../../Services/API";
import { ENDPOINTS } from "utils/endpoints";

export const fetchCustomerHistory = ({ mtn, serviceType, accountId,accountName }) => async dispatch => {
  dispatch({ type: FETCH_CUSTOMER_HISTORY_BEGIN });
  try {
    let value = "";
    
    if (serviceType && typeof serviceType === "string" && serviceType.toLowerCase() === "vzt") {
      value = `${accountId}_VZT`;
    } else if(serviceType && typeof serviceType ===  "string" && serviceType.toLowerCase() === "autoapp") {
      value = accountName;
    } else if(serviceType && typeof serviceType ===  "string" && serviceType.toLowerCase() === "ip") {
      value = accountName;
    }else {
      value = mtn;
    }
    const data = {
      identifier: "mtn",
      value
    };

    const response = await API({
      method: "POST",
      url: ENDPOINTS.AGENT_FETCH_CUSTOMER_HISTORY,
      data
    }).catch(err => dispatch({ type: FETCH_CUSTOMER_HISTORY_FAILURE }));

    if (response && response.data && response.data.hasOwnProperty("elementsData")) {
      dispatch({
        type: FETCH_CUSTOMER_HISTORY_SUCCESS,
        payload: response.data
      });
    } else {
      dispatch({ type: FETCH_CUSTOMER_HISTORY_FAILURE });
    }
  } catch (error) {
    dispatch({ type: FETCH_CUSTOMER_HISTORY_FAILURE });
  }
};
